import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../Util/authHeader";
import UserRestriction, { UserRestrictionForAge } from "../Components/UserRestriction";
import GlobalModals from "../Components/GlobalModals";
import BottomPlayerBar from "../Components/BottomPlayerBar/BottomPlayerBar";

export default function PrivateRoutes({ children }) {
  const navigate = useNavigate();

  let token = getAccessToken();
  useEffect(() => {
    if (!token) {
      navigate("/login", { replace: true });
    }
  }, [token]);

  return (
    <>
      {children}
      <UserRestriction />
      <UserRestrictionForAge />
      {/* <GlobalModals /> */}
      <BottomPlayerBar />
    </>
  );
}
